import { Box, FormControl, SxProps, Theme } from '@mui/material';

type SingleSelectProps = Readonly<{
  options: string[];
  onSelect: (option: string) => void;
}>;

export const SingleSelect = ({ options, onSelect }: SingleSelectProps) => {
  return (
    <FormControl fullWidth sx={{ mb: 1 }}>
      <Box sx={optionsContainerStyle}>
        {options.map((option, index) => (
          <Box
            key={index}
            onClick={() => {
              onSelect(option);
            }}
            sx={optionsStyle}
          >
            {option}
          </Box>
        ))}
      </Box>
    </FormControl>
  );
};

const optionsContainerStyle: SxProps<Theme> = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1,
} as const;

const optionsStyle: SxProps<Theme> = ({ typography, backrs }) =>
  ({
    padding: `${backrs.spacing['spacing-sm']} ${backrs.spacing['spacing-xl']}`,
    borderRadius: backrs.radius['radius-md'],
    border: `2px solid ${backrs.colors['Colors/Background/bg-brand-primary']}`,
    backgroundColor: backrs.colors['Colors/Background/bg-brand-primary'],
    color: backrs.colors['Colors/Foreground/fg-brand-secondary'],
    cursor: 'pointer',
    userSelect: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...typography['text-sm-medium'],
  }) as const;
